<div class="auth-flow-wrapper">
  <app-loading *ngIf="isLoading$ | async" [options]="loadingOpts$ | async"> </app-loading>

  <div class="auth-flow-container">
    <div class="auth-flow-title mb-8px">Sign In</div>

    <lib-reactive-form-group #form [bindTo]="req$ | async" (formSubmitted$)="formSubmitted($event)">
      <lib-reactive-form-email
        data-testid="sign-in-email-input"
        [inputName]="'email'"
        [label]="'Email'"
        [bindingProperty]="'email'"
        [required]="true"
        [showRequiredAsterisk]="false"
        [placeholder]="'Enter your email'">
      </lib-reactive-form-email>

      <lib-reactive-form-password
        data-testid="sign-in-password-input"
        [inputName]="'password'"
        [required]="true"
        [label]="'Password'"
        [showHidePassword]="true"
        [placeholder]="'Enter your password'"
        (keydown.enter)="form.submitForm()"
        [bindingProperty]="'password'">
      </lib-reactive-form-password>

      <lib-reactive-form-checkbox
        data-testid="sign-in-remember-me-checkbox"
        [inputName]="'rememberMe'"
        [disabled]="false"
        [selectedValue]="true"
        [notSelectedValue]="false"
        [bindingProperty]="'rememberMe'">
        Remember me
      </lib-reactive-form-checkbox>
    </lib-reactive-form-group>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-24px">
      <lib-button-primary
        data-testid="sign-in-submit-button"
        [disabled]="form.hasErrors$ | async"
        (buttonClicked)="form.submitForm()">
        Continue
      </lib-button-primary>

      <lib-button-text data-testid="sign-in-forgot-password-button" (buttonClicked)="secondaryButtonPressed()">
        Forgot Password?
      </lib-button-text>
    </div>
  </div>
</div>
